import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#6e9a35',
        secondary: '#1B5E20',
        accent: '#455A64',
        error: '#a61f38',
      },
    },
  },
}

export default new Vuetify(opts)